import React from 'react';
import Button from '../ui/Button';
const HeroSection = () => {
  return <section className="bg-gradient-to-r from-indigo-900 to-purple-900 text-white" data-id="element-171">
      <div className="container mx-auto px-4 py-16 md:py-24 flex flex-col md:flex-row items-center" data-id="element-172">
        <div className="w-full md:w-1/2 mb-10 md:mb-0 md:order-1 order-1" data-id="element-173">
          <div className="relative" data-id="element-174">
            <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Professional male executive working at desk" className="rounded-lg shadow-2xl w-full" data-id="element-175" />
            <div className="absolute -bottom-4 -right-4 bg-indigo-800 text-white py-2 px-4 rounded-lg shadow-lg" data-id="element-176">
              <p className="font-semibold" data-id="element-177">Clinically Proven</p>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 md:pl-8 md:order-2 order-2 mt-8 md:mt-0" data-id="element-178">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-179">
            NightPhase: The Executive Performance Sleep Patch
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-indigo-100" data-id="element-180">
            Harness a four-plant botanical patch with transdermal NightPhase
            Delivery™ for natural, non-melatonin sleep and peak performance
          </p>
          <a href="https://get.myhealthbeam.com/mptestcheck" className="inline-block w-full md:w-auto" data-id="element-181">
            <Button className="text-xl px-8 py-4 w-full" data-id="element-182">
              View Executive Packages
            </Button>
          </a>
        </div>
      </div>
    </section>;
};
export default HeroSection;